import { useCallback, useEffect } from 'react';

export default function useIsClickedOutside(target: HTMLElement | null, callback: (isClickedOutside: boolean) => void) {
    const onDocumentClick = useCallback(
        (event) => {
            if (target) {
                callback(!target.contains(event.target));
            }
        },
        [target, callback],
    );

    useEffect(() => {
        if (!target) {
            return;
        }

        document.addEventListener('click', onDocumentClick);
        document.addEventListener('ontouchend', onDocumentClick);
        return () => {
            document.removeEventListener('click', onDocumentClick);
            document.removeEventListener('ontouchend', onDocumentClick);
        };
    }, [target, callback, onDocumentClick]);
}
